module.exports = __webpack_public_path__ + "img/clarity.e8ce83a.jpg";